import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import Dialog from '../../atoms/feedback/Dialog'
import { useClientEvaluationCommentEditDialog } from '../../../hooks/useDialog'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Button from '../../atoms/inputs/Button'
import TextField from '../../atoms/inputs/TextField'
import { CompanyActions } from '../../../store/company'

export default function ClientEvaluationCommentEditDialog() {
  const { state, close } = useClientEvaluationCommentEditDialog()
  const [comment, setComment] = useState<string | undefined>(state?.comment)
  const dispatch = useDispatch()

  const handleSave = useCallback(() => {
    if (state && comment) {
      dispatch(
        CompanyActions.saveClientEvaluationComment({
          clientCompanyId: state.companyId,
          commentId: state.commentId,
          comment,
        })
      )
    }
  }, [comment, dispatch, state])

  return (
    <Dialog
      open={state !== undefined}
      onClose={close}
      title="評価コメントの編集"
      actions={
        <FlexRow>
          <Button variant="text" onClick={close}>
            キャンセル
          </Button>
          <Button onClick={handleSave}>保存</Button>
        </FlexRow>
      }
    >
      <FlexColumn>
        <TextField multiline rows={10} value={comment} onChange={setComment} />
      </FlexColumn>
    </Dialog>
  )
}
